module.exports = __webpack_public_path__ + "8583fd5343e7a5ffc67bbb22f14b7c1f.jpg";